<template>
    <div>
        <el-row>
            <el-col :span="24">
                <el-form :model="user" :rules="rules" ref="user" label-width="130px" class="user-form" size="mini">
                    <el-form-item label="用户名" prop="userName" >
                        <el-input placeholder="请输入QQ号" v-model="user.userName" :disabled="isDisabled"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="userRealName">
                        <el-input v-model="user.userRealName"></el-input>
                    </el-form-item>
                    <el-form-item label="角色" prop="roleCode">
                        <el-select v-model="user.roleCode" filterable placeholder="请选择" @change="roleChange">
                            <el-option
                            v-for="item in roles"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phoneNo">
                        <el-input v-model="user.phoneNo" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input v-model="user.email"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="userStatus">
                        <el-select v-model="user.userStatus" filterable placeholder="请选择">
                            <el-option
                            v-for="item in dataStatuses"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单位" prop="unit">
                        <el-input v-model="user.unit"></el-input>
                    </el-form-item>
                    <el-form-item label="组织部门" prop="deptName">
                        <el-input v-model="user.deptName"></el-input>
                    </el-form-item>
                    <el-form-item label="职称" prop="post">
                        <el-input v-model="user.post"></el-input>
                    </el-form-item>
                    <el-form-item label="导师/上级" prop="parentId">
                        <el-select v-model="user.parentId" filterable clearable placeholder="请选择">
                            <el-option
                            v-for="item in parentUsers"
                            :key="item.userId"
                            :label="item.userRealName"
                            :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="businessLicense">
                        <el-input v-model="user.businessLicense"></el-input>
                    </el-form-item>
                    <el-form-item label="公司存续状态" prop="survivalStatus">
                        <el-input v-model="user.survivalStatus"></el-input>
                    </el-form-item>
                    <el-form-item label="代理/收送样员" prop="agentId">
                        <el-select v-model="user.agentId" filterable clearable placeholder="请选择">
                            <el-option
                            v-for="item in agentUsers"
                            :key="item.userId"
                            :label="item.userRealName"
                            :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收货地址" prop="address">
                        <el-input v-model="user.address"></el-input>
                    </el-form-item>
                    <el-form-item label="客户等级" prop="userLevel">
                        <el-select v-model="user.userLevel" filterable placeholder="请选择">
                            <el-option
                            v-for="item in userLevels"
                            :key="item.dictCode"
                            :label="item.dictDesc"
                            :value="item.dictCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否测序" prop="isSequencing">
                            <el-select v-model="user.isSequencing" clearable filterable placeholder="请选择" @change="isSequencingChange">
                                <el-option
                                v-for="item in yesOrNo"
                                :key="item.dictCode"
                                :label="item.dictDesc"
                                :value="item.dictCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="送测公司" prop="sequenceCompany" v-if="isShowSequenceCompany">
                            <el-select v-model="user.sequenceCompany" clearable filterable placeholder="请选送测公司">
                                <el-option
                                v-for="item in seqCompanys"
                                :key="item.companyName"
                                :label="item.companyName"
                                :value="item.companyName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    <el-form-item label="余额" prop="balance">
                        <el-input v-model="user.balance" :readonly="true"></el-input>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-row class="row-button">
            <el-button size="mini" type="primary" @click="submitForm('user')">提交</el-button>
            <el-button size="mini" @click="cancel">取消</el-button>
        </el-row>
    </div>
</template>

<script>
import GlobeConstant from '../../assets/js/GlobeConstant';

    export default {
    name: "UserUpdate",
    props: ["userProp"],
    components: {
    },
    data() {
        var validateUserName = (rule, value, callback) => {
            if(value) {
                let reg = /^[0-9]{1,20}$/
                if(!reg.test(value)) {
                    callback(new Error("请输入正确的QQ号"));
                }
            }
            callback();
        };
        var validatePhoneNo = (rule, value, callback) => {
            if(!value) {
                callback();
            } else {
                let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
                if(!reg.test(value)) {
                    callback(new Error("请输正确的手机号"));
                }
            }
            callback();
        };  

        return {
            user: {
                userName: "",
                realName: "",
                userType: "",
                teamId: "",
            },
            rules: {
                userName: [
                    { required: true, message: "请输入用户名", trigger: "blur" },
                    { validator: validateUserName, trigger: "blur" },
                ],
                userRealName: [
                    { required: true, message: "请输入真实姓名", trigger: "blur" },
                    { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
                ],
                phoneNo: [
                    { required: true, message: "请输入手机号", trigger: "blur" },
                    { validator: validatePhoneNo, trigger: "blur" }
                ],
                roleCode: [
                    { required: true, message: "请选择角色", trigger: "change" }
                ],
                email: [
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
                sequenceCompany: [
                    { required: true, message: "请输入测序公司", trigger: "blur" }
                ],
            },
            dictTypeUserType: "user_type",
            dictTypeTeam: "team",
            isDisabled: false,
            roles:[],
            restaurants: [],
            state: '',
            timeout:  null,
            dataStatuses: [],
            parentUsers: [],
            agentUsers: [],
            userLevels: [],
            yesOrNo: [],
            seqCompanys: [],
            isShowSequenceCompany: false,
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/user/save", this.user).then(res => {
                        if (res.data.status === "success") {
                            this.$message({
                                message: "提交成功！",
                                type: "success"
                            });
                            this.$bus.$emit(GlobeConstant.userupdate_to_user_close);
                            this.$bus.$emit(GlobeConstant.userupdate_to_userlist_close);
                        } else {
                            this.$message.error(res.data.message);
                        }
                    }, error => {
                        this.$message.error(error.message);
                    });
                } else {
                    return false;
                }
            });
        },
        cancel() {
            this.$bus.$emit(GlobeConstant.userupdate_to_user_close);
            this.$bus.$emit(GlobeConstant.userupdate_to_userlist_close);
        },
        querySearchAsync(queryString, cb) {
            var restaurants = this.restaurants;
            var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
            cb(results);
            }, 3000 * Math.random());
        },
        createStateFilter(queryString) {
            return (state) => {
            return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        queryUserStatus() {
            let condition = {value:"USER_STATUS"};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.dataStatuses = res.data.result;
                    }else {
                            this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        queryDicts(dictType) {
            let condition = {value:dictType};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        if(dictType === 'YES_NO') {
                            this.yesOrNo = res.data.result;
                        }
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        queryRoles() {
            let condition = {value:"ROLE"};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.roles = res.data.result;
                    }else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        queryUserLevels() {
            let condition = {value:"USER_LEVEL"};
            this.$axios.post("/dictionary/findByDictType",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.userLevels = res.data.result;
                    }else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        roleChange() {
            if(this.user.roleCode === "ORDINARY") {
                this.initRole();
            } else {
                this.parentUsers = [];
            }
            
            this.$set(this.user, "parentId", "");
        },
        initRole() {
            if(this.user.roleCode === "ORDINARY") {
                let condition = {value : "RESPONSIBLE"};
                this.$axios.post("/user/findByRoleCode",condition).then(
                    res=>{
                        if(res.data.status === "success"){
                            this.parentUsers = res.data.result;
                            let index = this.parentUsers.findIndex(it=>it.userId === this.user.userId);
                            if(index !== -1) {
                                this.parentUsers.splice(index, 1);
                            }
                        }else {
                            this.$message.error(res.data.message);
                        }
                    },
                    error=>{
                        this.$message.error(error.message);
                    }
                )
            }
        },
        queryAgent() {
            let condition = {value : "AGENT"};
            this.$axios.post("/user/findByRoleCode",condition).then(
                res=>{
                    if(res.data.status === "success"){
                        this.agentUsers = res.data.result;
                        let index = this.agentUsers.findIndex(it=>it.userId === this.user.userId);
                        if(index !== -1) {
                            this.agentUsers.splice(index, 1);
                        }
                    }else {
                        this.$message.error(res.data.message);
                    }
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
        isSequencingChange() {
            if(this.user.isSequencing === 'Y') {
                this.isShowSequenceCompany = true;
            }else {
                this.isShowSequenceCompany = false;
                this.$set(this.user, "sequenceCompany", "");
            }

            //this.$set(this.orderInfo, "upstreamSiteId", "");
            //this.$set(this.orderInfo, "downstreamSiteId", "");
        },
        querySeqCompany() {
            this.$axios.post("/seqCompany/findList").then(
                res=>{
                    if(res.data.status === "success"){
                        this.seqCompanys = res.data.result;
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.loading = false;
                },
                error=>{
                    this.$message.error(error.message);
                }
            )
        },
    },
    created() {
        this.user = this.userProp;
        if (this.userProp.id) {
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
        this.queryUserStatus();
        this.queryRoles();
        this.initRole();
        this.queryAgent();
        this.queryUserLevels();
        this.queryDicts("YES_NO");
        this.querySeqCompany();
        this.isSequencingChange();
    },
}


</script>

<style scoped>

   .user-form {
       margin: 20px 20px 20px 20px;
   }
   .block {
       text-align: right;
       margin-top: 10px;
   }
   .el-select {
        width: 100%;
    }
    .row-button {
        display: flex;
        justify-content: right;
        border-top: solid 1px;
   }

   .row-button >.el-button {
        margin-top: 10px;
        margin-right: 10px;
   }

</style>
